<template lang="pug">
.promos-header(:class="getClass")
  PromosHeaderLogo
  PromosHeaderController(
    v-if="is_mobile",
    :isOpened="is_menu_opened",
    @click="toggleMenu"
  )
  component(:is="getUserComponent")

</template>

<script>
import PromosHeaderLogo from "./blocks/PromosHeaderLogo";
import PromosHeaderUser from "./blocks/PromosHeaderUser";
import PromosHeaderUserMobile from "./blocks/PromosHeaderUserMobile";
import PromosHeaderController from "./blocks/PromosHeaderController";
import MobileDetectionMixin from "@chronos/frontend-base/src/mixins/mobile_detection/MobileDetectionMixin";

export default {
  name: "PromosHeader",
  components: {
    PromosHeaderLogo,
    PromosHeaderController,
  },
  mixins: [MobileDetectionMixin],
  data() {
    return {
      is_menu_opened: false,
      mobile_breakpoint: 720,
    };
  },
  computed: {
    getUserComponent() {
      return this.is_mobile ? PromosHeaderUserMobile : PromosHeaderUser;
    },
    getClass() {
      return { "promos-header--opened": this.is_menu_opened };
    },
  },
  methods: {
    toggleMenu() {
      this.is_menu_opened = !this.is_menu_opened;

      if (this.is_menu_opened) {
        document.querySelector("body").classList.add("body-overflow");
      } else {
        document.querySelector("body").classList.remove("body-overflow");
      }
    },
  },
}
</script>

<style lang="scss">
  @import "../styles/header";
</style>